import ItemService from './ItemService';
import ContainerService from './ContainerService';
import InventoryService from './InventoryService';
import AuthoriseService from './AuthoriseService';
import CompletionRecordService from './CompletionRecordServices';
import CompletionLockerNotesService from './CompletionLockerNotesService';
import InventoryGalleryService from './InventoryGalleryService';
import InventoryManageService from './InventoryManageService';
import HoseManagementService from './HoseManagementService';

class ServiceAPI {
  
  Item = () => {
    return new ItemService();
  }

  Container = () => {
    return new ContainerService();
  }
  
  Inventory = () => {
    return new InventoryService();
  }

  Authorise = () => {
    return new AuthoriseService();
  }

  CompletionRecord = () => {
    return new CompletionRecordService();
  }

  CompletionLockerNotes = () => {
    return new CompletionLockerNotesService();
  }

  InventoryGallery = () => {
    return new InventoryGalleryService();
  }

  InventoryManage =() => {
    return new InventoryManageService();
  }

  HoseManagement = () => {
    return new HoseManagementService();
  }
}

export default new ServiceAPI();
